const { autoPublicPath } = require("./auto-public-path");

autoPublicPath(1);
